import styled, { css } from "styled-components";

import { theme } from "../../../../styles/theme";
import { Checked } from "../../../../assets/svgs";

interface OptionWrapperProps {
  selected: boolean;
  label2?: any;
}

export const Container = styled.div`
  margin-bottom: 20px;
  width: 100%;
`;

export const OptionsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;

  & > label {
    display: flex;
    gap: 8px;
    align-items: center;

    div {
      color: ${theme.colors.white};
      font-size: ${theme.font.sizes.normal};
      font-family: ${theme.font.poppins};
      font-weight: ${theme.font.semiBold};
    }
  }
`;

export const OptionWrapper = styled.div<OptionWrapperProps>`
  display: flex;
  height: 90px;
  justify-content: center;
  padding: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  flex-direction: column;
  border-radius: 16px;
  gap: 10px;
  box-shadow: 0px 0px 10px 0px rgba(117, 117, 117, 0.3);

  ${(props) =>
    props.selected &&
    css`
      border: 3px solid var(--cores-da-marca-verde-2, #0e9658);
      background: var(--cores-da-marca-verde-claro, #e0f6cc);
      box-shadow: 0px 0px 10px 0px rgba(117, 117, 117, 0.1);
    `}

  label {
    display: flex;
    align-items: center;
    margin-left: 10px;
    gap: 10px;
    ${(props) =>
      props.selected &&
      css`
        color: ${theme.colors.green2};
      `}
  }
`;

export const CheckboxInput = styled.input`
  background: ${(props) => (props.checked ? Checked : theme.colors.blue900)};
  width: 20px;
  height: 20px;
  cursor: pointer;
`;

export const DivOptions = styled.div`
  display: flex;
  align-items: baseline;
  gap: 10px;
`;

export const OptionText = styled.span<OptionWrapperProps>`
  margin-left: 10px;
  font-size: 25px;
  font-style: normal;
  font-weight: 700;
  color: ${theme.colors.gray400};
  ${(props) =>
    props.selected &&
    css`
      color: ${theme.colors.green2};
    `}
`;

export const OptionText2 = styled.span<OptionWrapperProps>`
  font-size: 15px;
  font-style: normal;
  color: ${(props) =>
    props.selected ? theme.colors.green2 : theme.colors.gray400};
  font-weight: 700;
  position: relative;

  ::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 10px;
    width: 100%;
    height: 1px;
    background-color: ${(props) =>
      props.selected ? theme.colors.green2 : theme.colors.gray400};
    visibility: visible;
  }
`;

export const OptionText3 = styled.span`
  font-weight: 900;
  margin-left: 15px;
`;
